import { createAsyncThunk } from "@reduxjs/toolkit";
import { createUserAPI, deleteUserByIdAPI, fetchAllAdminAPI, updateUserAPI } from "./userManagementAPI";
import { fetchUnassignedLocations } from "../location/locationThunk";
import { updatePasswordAPI } from "../auth/authAPI";

/// Creating User
export const createUser = createAsyncThunk("user-managment/createUser", async (body, {rejectWithValue}) =>{
    try {
        const response = await createUserAPI(body)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

/// Creating User
export const updateUser = createAsyncThunk("user-managment/updateUser", async (body, {rejectWithValue}) =>{
    try {
        const response = await updateUserAPI(body)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Fetching all Admin user
export const fetchAllAdminUser = createAsyncThunk("user-management/fetchAllAdminUser", async  (_, {rejectWithValue}) => {
    try {
        const response = await  fetchAllAdminAPI()
              console.warn("All response", response);
        return response
    } catch (error) {
        console.warn("All Admin Errors");
        
        return rejectWithValue(error)
    }
})

// export const fetchAllAdminUser = createAsyncThunk(
//     "user-management/fetchAllAdminUser",
//     async (id, { rejectWithValue }) => {
//         try {
//             // Fetch both simultaneously using Promise.all
//             const [allAdmins, unassignedLocations] = await Promise.all([
//                 fetchAllAdminAPI(),
//                 fetchUnassignedLocations()
//             ]);
//             return { allAdmins, unassignedLocations };
//         } catch (error) {
//             return handleThunkError(error, rejectWithValue);
//         }
//     }
// );

export const fetchUsersWithLocations = createAsyncThunk(
    "user-management/fetchUsersWithLocations",
    async (id, { rejectWithValue, dispatch }) => {
        try {
            await dispatch(fetchAllAdminUser())
            return await dispatch(fetchUnassignedLocations())
        } catch (error) {
            return handleThunkError(error, rejectWithValue);
        }
    }
);


/// Deleting User by id
export const deleteUserById = createAsyncThunk("user-management/deleteUserById", async (id, {rejectWithValue}) => {
    try {
        const response = await deleteUserByIdAPI(id)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

export const updatePassword = createAsyncThunk("auth/updatePassword", async (body, {rejectWithValue}) => {
    try {
        const response = await updatePasswordAPI(body)
        return response
    } catch (error) {        
        return rejectWithValue(error)
    }
})
